module.exports = __webpack_public_path__ + "static/media/lv_dry_lemon.b1f723a9.png";